import React from 'react';
import Overlay from '../../../components/Overlay';
import Modal from '../../../components/Modal';
import './ReportModal.scss';
import Button from '../../../components/Button';

const ReportModal = ({
  setShowReportModal,
  isEditMode,
  handleSaveReport,
  report,
  setReport,
  saveStatus,
  deleteStatus,
  updateStatus,
  useCurrentParams,
  setUseCurrentParams,
  handleDeleteReport,
}) => {
  return (
    <Overlay close={() => setShowReportModal(false)} show>
      <Modal className="report-modal">
        <h3>{`${isEditMode ? 'Edit' : 'Save as'} Report`}</h3>
        <div className="p-1 w-100">
          {!isEditMode && (
            <div className="mb-3" style={{ color: '#444' }}>
              Save this as a report so you can easily access it in the future.
            </div>
          )}
          <div className="form-group">
            <label>Report Name</label>
            <input
              className="w-100"
              onChange={(e) =>
                setReport((prev) => ({ ...prev, name: e.target.value }))
              }
              value={report.name}
            />
          </div>
          <div className="form-group mt-4">
            <label>Report Description (Optional)</label>
            <textarea
              className="w-100"
              onChange={(e) =>
                setReport((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
              value={report.description}
            />
          </div>
          {isEditMode && (
            <div className="form-group mt-4 d-flex align-items-center justify-content-start mb-4">
              <input
                type="checkbox"
                checked={useCurrentParams}
                onChange={() => setUseCurrentParams((prev) => !prev)}
                style={{ height: 16, width: 16, cursor: 'pointer' }}
              />
              <div className="ml-3 mb-0">
                Update settings to current selections
              </div>
            </div>
          )}
        </div>
        <div className="align-self-end w-100 d-flex align-items-end">
          <Button
            fullWidth
            className="mt-3 mr-3"
            loading={saveStatus.loading}
            onClick={() => setShowReportModal(false)}
            appearance="subtle"
          >
            Cancel
          </Button>
          {isEditMode && (
            <Button
              fullWidth
              className="mt-3 mr-3"
              loading={deleteStatus.loading}
              onClick={() => {
                handleDeleteReport();
                setShowReportModal(false);
              }}
              appearance="red2"
            >
              Delete
            </Button>
          )}
          <Button
            fullWidth
            className="mt-3"
            loading={saveStatus.loading || updateStatus?.loading}
            onClick={() => {
              if (!report.name.length) return;
              handleSaveReport();
            }}
            disabled={!report.name.length}
          >
            Save
          </Button>
          {saveStatus.error && <div>There was an error.</div>}
        </div>
      </Modal>
    </Overlay>
  );
};

export default ReportModal;
